import styles from './Skills.module.css';
import SkillCard from '../SkillCard/SkillCard';
import { useEffect, useRef } from 'react';

/*

To add new skill categories or skills, follow these steps:

1. Define a new array for the skill category (e.g., const newCategorySkills = ['Skill1', 'Skill2'];).
2. Create a new useRef for the skill category (e.g., const newCategoryRef = useRef(null);).
3. Add the new category and its ref to the refArray (e.g., const refArray = [frontendRef, backendRef, toolsRef, newCategoryRef];).
4. Add a new SkillCard component for the category (e.g., <SkillCard title="New Category" skills={newCategorySkills} ref={newCategoryRef} />).

*/

const Skills = () => {
  const skillsRef = useRef<HTMLElement>(null);
  const frontendRef = useRef<HTMLDivElement>(null);
  const backendRef = useRef<HTMLDivElement>(null);
  const toolsRef = useRef<HTMLDivElement>(null);

  const frontendSkills = ['HTML', 'CSS', 'JavaScript', 'React', 'AngularJS', 'TypeScript'];
  const backendSkills = ['Node.js', 'Express', 'PostgreSQL', 'Firebase'];
  const tools = ['VS Code', 'Git', 'Figma', 'Vite'];

  useEffect(() => {
    const refArray = [frontendRef, backendRef, toolsRef];

    const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
    const delayLoop = async (ms: number) => {
      await delay(ms);
    };

    const observer = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        for (const ref of refArray) {
          if (ref.current) {
            ref.current.classList.add('inView');
          }
          await delayLoop(200);
        }
      }
    });

    const skillsNode = skillsRef.current;

    if (skillsNode) {
      observer.observe(skillsNode);
    }

    return () => {
      if (skillsNode) {
        observer.unobserve(skillsNode);
      }
    };
  }, []);

  return (
    <section className={styles.section} id="skills" ref={skillsRef}>
      <h2 className={styles.title}>Skills</h2>
      <div className={styles.skillsContainer}>
        <SkillCard title="Frontend" skills={frontendSkills} ref={frontendRef} />
        <SkillCard title="Backend" skills={backendSkills} ref={backendRef} />
        <SkillCard title="Tools" skills={tools} ref={toolsRef} />
      </div>
    </section>
  );
};

export default Skills;

